<template>
  <div>
    <MaterialPreview
      v-model="materialPreviewId"
      :material="selectedMaterialForPreview"
      :is-image="false"
    />
    <Carousel
      v-for="part in parts"
      :key="part + getContent(part).length /* to force re-render */"
      :kind="kind"
      :part="part"
      :has-at-least-one-image="hasImage"
      :is-no-image="isNoImage"
      :choices="getContent(part)"
      :is-loading="loadingState[part]"
      :startIndex="getStartIndex(part)"
      :selected-image-source-type="selectedImageSourceType"
      :selected-image-source-variant="selectedImageSourceVariant"
      :topic-id="topicId"
      :is-stock-photos-ready="isStockPhotosReady"
      @openEditTextDialog="openEditTextDialog"
      @change="handleChange"
      @image-updated="handleImageUpdate"
      @openVideoPreview="handleOpenVideoPreview"
    />
  </div>
</template>

<script>
import MaterialPreview from '@/modules/adMaterials/MaterialPreview.vue'

import Carousel from './Carousel'
import { partMapper } from './lib/partMapper'

export default {
  components: {
    Carousel,
    MaterialPreview,
  },
  props: {
    kind: {
      type: String,
      default: '',
    },
    selectedContent: {
      type: Object,
      default: () => {},
    },
    generatedContent: {
      type: Object,
      default: () => {},
    },
    hasImage: {
      type: Boolean,
      default: false,
    },
    isNoImage: {
      type: Boolean,
      default: false,
    },
    loadingState: {
      type: Object,
      default: () => ({
        text: false,
        image: false,
      }),
    },
    selectedImageSourceType: {
      type: String,
      default: '',
    },
    selectedImageSourceVariant: {
      type: String,
      default: '',
    },
    topicId: {
      type: String,
      required: true,
    },
    isStockPhotosReady: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      materialPreviewId: '',
      selectedMaterialForPreview: null,
    }
  },
  computed: {
    parts() {
      return partMapper[this.kind].filter(this.getContent).filter((value) => {
        if (this.isNoImage && this.kind === 'newsletter') {
          return true
        }
        if (this.isNoImage) return value !== 'image'
        return value
      })
    },
  },
  methods: {
    getContent(part) {
      return {
        text: () => this.generatedContent?.text?.choices,
        title: () => this.generatedContent?.title?.choices,
        image: () => this.generatedContent?.image?.choices,
      }[part]()
    },
    getStartIndex(part) {
      return this.generatedContent?.[part]?.choices?.findIndex(
        {
          text: (choice) => choice === this.selectedContent?.text,
          title: (choice) => choice === this.selectedContent?.title,
          image: (choice) => choice.id === this.selectedContent?.image?.id,
        }[part]
      )
    },
    openEditTextDialog(index) {
      this.$emit('openEditTextDialog', index)
    },
    handleChange(data) {
      if (data.choices) {
        this.$emit('change', {
          part: data.part,
          content: data.content,
          generatedContent: {
            ...this.generatedContent,
            [data.part]: { choices: data.choices },
          },
        })
      } else {
        this.$emit('change', { part: data.part, content: data.content })
      }
    },
    handleImageUpdate(imageData) {
      this.$emit('image-updated', imageData)
    },
    handleOpenVideoPreview(videoContent) {
      this.selectedMaterialForPreview = {
        id: videoContent.id || 'video-preview',
        displayName: 'Video',
        url: videoContent.url || videoContent.preview,
        previewUrl: videoContent.preview || videoContent.url,
        assetType: 'VIDEO',
        createdAt: new Date().toISOString(),
      }
      this.materialPreviewId = videoContent.id || 'video-preview'
      if (this.$tracking) {
        this.$tracking.event('Content Creator', 'Clicked', 'Video-Preview')
      }
    },
  },
  emits: ['openEditTextDialog', 'change', 'image-updated'],
}
</script>
